import React from 'react'
import Chat from './Chatfile'

const Chatpage = () => {
  return (
    <div className="bg-white rounded-lg p-6 w-full md:max-w-[400px] h-[500px] overflow-y-auto fixed  md:bottom-0 md:top-auto top-[60px] bottom-auto right-0 z-[99] md:min-h-0 min-h-screen chatpage" style={{boxShadow:"0px 0px 10px #000"}}><Chat /></div>
  )
}

export default Chatpage